var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-submenu",
    { attrs: { index: "" + _vm.model.id } },
    [
      _c("template", { slot: "title" }, [
        _c("span", [_vm._v(_vm._s(_vm.printTitle(_vm.model)))])
      ]),
      _vm._v(" "),
      _c("drop-list", {
        attrs: {
          mode: "cut",
          "no-animations": "",
          items: _vm.model[_vm.listKey],
          row: true
        },
        on: { insert: _vm.onInsert, reorder: _vm.onReorder },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("drag", {
                  key: item.id,
                  attrs: {
                    tag: "tree-item",
                    model: item,
                    data: item,
                    list: item[_vm.listKey],
                    "list-key": _vm.listKey
                  },
                  on: {
                    cut: function($event) {
                      return _vm.remove(item)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "feedback",
            fn: function(ref) {
              var data = ref.data
              return [
                _c("div", {
                  key: "feedback-" + data.id,
                  staticClass: "feedback"
                })
              ]
            }
          },
          {
            key: "reordering-feedback",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", {
                  key: "reordering-feedback-" + item.id,
                  staticClass: "reordering-feedback"
                })
              ]
            }
          }
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }